"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendWebsocketActions = exports.BackendWebsocketActions = exports.CardColor = exports.CardSymbol = void 0;
// Shared models
var CardSymbol;
(function (CardSymbol) {
    CardSymbol["DIAMOND"] = "DIAMOND";
    CardSymbol["WAVE"] = "WAVE";
    CardSymbol["STAR"] = "STAR";
    CardSymbol["DOTS"] = "DOTS";
    CardSymbol["CIRCLE"] = "CIRCLE";
    CardSymbol["PLUS"] = "PLUS";
    CardSymbol["PAUSE"] = "PAUSE";
    CardSymbol["HASH"] = "HASH";
})(CardSymbol = exports.CardSymbol || (exports.CardSymbol = {}));
var CardColor;
(function (CardColor) {
    CardColor["BLACK"] = "#112633";
    CardColor["RED"] = "#C84C2B";
    CardColor["ORANGE"] = "#F78C5A";
    CardColor["NAVY"] = "#18414B";
    CardColor["SAND"] = "#D99E7F";
})(CardColor = exports.CardColor || (exports.CardColor = {}));
// Websockets
var BackendWebsocketActions;
(function (BackendWebsocketActions) {
    BackendWebsocketActions["PlayerIdSet"] = "player_id_set";
    BackendWebsocketActions["PlayerPoolUpdated"] = "player_pool_updated";
    BackendWebsocketActions["GameUpdated"] = "game_updated";
    BackendWebsocketActions["RoomNotFound"] = "room_not_found";
    BackendWebsocketActions["AdminDisconnected"] = "admin_disconnected";
    BackendWebsocketActions["AddPlayerFailed"] = "add_player_failed";
    BackendWebsocketActions["GameScoreUpdated"] = "game_score_updated";
})(BackendWebsocketActions = exports.BackendWebsocketActions || (exports.BackendWebsocketActions = {}));
var FrontendWebsocketActions;
(function (FrontendWebsocketActions) {
    FrontendWebsocketActions["AdminJoined"] = "admin_joined";
    FrontendWebsocketActions["PlayerJoined"] = "player_joined";
    FrontendWebsocketActions["GameStarted"] = "game_started";
    FrontendWebsocketActions["CardDrawn"] = "card_drawn";
    FrontendWebsocketActions["CardWon"] = "card_won";
    FrontendWebsocketActions["GameEnded"] = "game_ended";
})(FrontendWebsocketActions = exports.FrontendWebsocketActions || (exports.FrontendWebsocketActions = {}));
